import { css } from '@emotion/react';
import React, { useCallback } from 'react';
import { UIColorPalette } from './ColorPalette';
import Symbols, { SymbolView } from './Symbols';

const Links = [
  { url: '/rules', label: 'Game Rules' },
  { url: '/all-cards', label: 'Cards List' },
  { url: '/all-cards#tributes', label: 'Tributes List' },
];

export default function CollapsibleGameLinksView(props: {}) {
  const [collapsed, setCollapsed] = React.useState(
    localStorage.getItem('CollapsibleGameLinksView_Collapsed') === 'true' ||
      false,
  );
  const onClick = useCallback(() => {
    localStorage.setItem(
      'CollapsibleGameLinksView_Collapsed',
      (!collapsed).toString(),
    );
    setCollapsed(!collapsed);
  }, [collapsed, setCollapsed]);

  let expandedBody: React.ReactNode = !collapsed && (
    <div css={ViewStyles.list}>
      {Links.map((definition, i) => {
        return (
          <a
            key={i}
            target="_blank"
            href={definition.url}
            css={ViewStyles.link}
          >
            {definition.label}
          </a>
        );
      })}
    </div>
  );

  const symbol_type = collapsed ? Symbols.ARROW_EXPAND : Symbols.ARROW_COLLAPSE;
  return (
    <div css={ViewStyles.container}>
      <span
        onClick={onClick}
        css={[ViewStyles.header, collapsed ? null : ViewStyles.headerExpanded]}
      >
        Mythos Info
        <span css={ViewStyles.button}>
          <SymbolView symbol={symbol_type} css={ViewStyles.symbol} />
        </span>
      </span>
      {expandedBody}
    </div>
  );
}

const ViewStyles = {
  container: css({
    fontSize: 13,

    color: UIColorPalette.lobbyDarkText,
    backgroundColor: UIColorPalette.collapsibleBg,
  }),
  list: css({
    display: 'flex',
    flexDirection: 'column',
    padding: 5,
  }),
  link: css({
    margin: 3,

    textDecoration: 'underline',

    color: UIColorPalette.collapsibleText,
  }),
  button: css({
    paddingRight: 5,
  }),
  header: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: 5,

    fontSize: 17,

    backgroundColor: UIColorPalette.collapsibleHeaderBg,
  }),
  headerExpanded: css({
    borderBottom: `1px solid ${UIColorPalette.collapsibleBorder}`,
  }),
  symbol: css({
    height: 17,
    width: 17,
  }),
} as const;
